import { callFetch, header } from "./utils";

const EndPoint = {
  VerifyCoupon: (lineId) => `/line/${lineId}/event-form/verify`,
  UpdateCoupon: (lineId) => `/line/${lineId}/event-form/redeem`,
};

export function verifyCoupon(lineId) {
  const uri = EndPoint.VerifyCoupon(lineId);
  let settings = {
    method: "GET",
    headers: header,
  };

  return callFetch(uri, settings);
}

export function exchangeCoupon(lineId, redeemCode) {
  const uri = EndPoint.UpdateCoupon(lineId);
  let settings = {
    method: "POST",
    headers: header,
    body: JSON.stringify({ redeemCode }),
  };

  return callFetch(uri, settings);
}
